namespace SP.Data {
    export class Customer {

        private static customerInfos: CustomerInfo[];
        private static customerInfo: { [customerId: string]: CustomerInfo } = {};

        static async getCustomerInfo(customerId: string, useCache = true) {
            if (useCache && this.customerInfo[customerId] != null) return this.customerInfo[customerId];
            var response = await SP.get<any>("/api/v1/info/customerInfo/" + customerId);
            if (response.status == 200) this.customerInfo[customerId] = response.data;
            else await SP.alertX(response.status + ": " + response.msg);
            return this.customerInfo[customerId];
        }

        static async getCustomerInfos(useCache = true) {
            if (useCache && this.customerInfos != null) return this.customerInfos;
            var response = await SP.get<any>("/api/v1/info/customerInfos");
            if (response.status == 200) this.customerInfos = response.data;
            else await SP.alertX(response.status + ": " + response.msg);
            return this.customerInfos;
        }

        static async getAllCustomerInfos() {
            let customerInfos: CustomerInfo[] = [];

            var response = await SP.get<any>("/api/v1/info/customersInfo");
            if (response.status == 200) {
                customerInfos = response.data;
            }
            else {
                await SP.alertX(response.status + ": " + response.msg);
            }

            return customerInfos;
        }
    }
}